import apiTabFromReduxTab from "./apiTabFromReduxTab";
import getApiSaveTabFields from "./getApiSaveTabFields";

export default function getApiTabToSave(reduxTab, reduxBinder) {
	const apiTab = apiTabFromReduxTab(reduxTab);
	return getApiSaveTabFields(apiTab, reduxBinder);
}
